<template xmlns:v-bind="http://www.w3.org/1999/xhtml">
	<transition name="slide-fade">
		<div class="page cv">
			<h1 class="cv-title">Adam Drobotij</h1>
			<h2 class="cv-email"><a href="mailto:hireme@robot-d.com">hireme@robot-d.com</a></h2>
			<a class="cv-pdf" href="/static/drobotij_resume_2017.pdf">pdf</a>
			<hr />
			<ul class="cv-list job-list">
				<li v-for="job in jobs" class="cv-li job">
					<div class="col__left">
						<h2 class="job__title">{{job.title}}</h2>
						<div class="job__dates">{{job.dates}}</div>
					</div>
					<div class="col__right">
						<div v-if="job.link">
							<h3 class="job__company"><a v-bind:href="job.link">{{job.company}}</a><span v-if="job.city"> &ndash; <span class="job__city">{{job.city}}</span></span></h3>
						</div>
						<div v-else>
							<h3 class="job__company">{{job.company}}</h3>
						</div>
						<p class="job__description" v-html="job.description">{{job.description}}</p>
					</div>
				</li>
			</ul>
			<hr />
			<ul class="cv-list education-list">
				<li class="cv-li">
					<h2 class="col__left cv__subhead">Education</h2>
					<div class="col__right">
						<h3 class="education__title">Carnegie Mellon University &ndash; <span class="">Pittsburgh, PA</span></h3>
						<p class="education__description"><span class="smallcaps">BFA</span> in Multimedia Art, with a secondary focus on Computer&nbsp;Science.</p>
					</div>
				</li>
			</ul>
			<hr />
			<ul class="cv-list skills-list">
				<li class="cv-li">
					<div class="col__left"><h2 class="cv__subhead">Strengths</h2></div>
					<div class="col__right"><p><span class="smallcaps">HTML</span>, <span class="smallcaps">CSS/SASS/LESS</span>, JavaScript, ReactJS, AngularJS, <span class="smallcaps">PHP</span>, MySQL, Swift iOS, Unity3D, C#, Javascript-based Animation, Drupal, WordPress, ExpressionEngine, jQuery, Bootstrap, SiteCore, <span class="smallcaps">SVN</span>&nbsp;&amp;&nbsp;Git,
						ActionScript3, Flash Animation, Adobe&nbsp;Suite</p></div>
				</li>
				<li class="cv-li">
					<div class="col__left"><h2 class="cv__subhead">Weaknesses</h2></div>
					<div class="col__right"><p>Homemade Pasta, Bourbon-based Cocktails, Overwatch, Experimental Video Games</p></div>
				</li>
			</ul>
		</div>
	</transition>
</template>
<style lang="scss" scoped>
	.cv {
		text-align: left;
	}
	.cv-title {
		margin: 0;
		font-size: 49px;
		font-weight: normal;
		line-height: 1.2;
	}
	.cv-email {
		font-weight: normal;
		font-size: 21px;
		margin: 0 0 20px;
		line-height: 1;
	}
	.cv-pdf {
		display: block;
		position: absolute;
		right: 0;
		top: 10px;

		width: 40px;
		height: 40px;
		background: url('/static/images/pdf-flat.png') no-repeat;
		-webkit-background-size: cover;
		background-size: cover;
		text-indent: 110%;
	}
	.cv hr {
		margin: 0;
	}
	.cv-list {
		margin: 0;
		padding: 0;
	}
	.cv-li {
		list-style: none;
		clear: both;
	}

	.col__left {
		float: left;
		width: 200px;
	}
	.col__right {
		margin-left: 220px;
	}

	.job {
	}
	.job__title {
		margin: 0 0 10px;
		font-size: 18px;
		font-style: italic;
	}
	.job__dates {

	}
	.job__company {
		font-size: 18px;
		margin: 18px 0 10px;
	}
	.job__city {
		font-size: 15px;
		font-weight: normal;
	}
	.job__description {
		margin: 0 0 48px;
	}

	.education-list {

	}
	.cv__subhead {
		font-size: 18px;
		margin: 0;
	}
	.skills-list {

	}

	@media only screen and (max-width: 600px) {
		.cv-title {
			font-size: 30px;
		}
		.cv-email {
			font-size: 18px;
		}
		.cv-pdf {
			top: 0;
		}
		.col__left {
			float: none;
			width: 100%;
		}
		.col__right {
			margin-left: 0;
			margin-bottom: 50px;
		}
		.job__title {
			display: block;
			line-height: 1;
			margin: 14px 0 0;
		}
		.job__dates {
			display: block;
		}
		.job__company {
			margin: 3px 0 10px;
			line-height: 1.2;
		}

		.cv__subhead {
			margin: 10px 0 12px;
		}
		.education__title {
			line-height: 1.2;
		}
	}
</style>
<script type="text/babel">
    export default{
        data() {
			return {
				jobs: [
					{
						title:       'Web Consultant',
						dates:       '2015 - Current',
						company:     'Robot D',
						city:        'Los Angeles, CA',
						description: 'Worked remotely to develop front-end web experiences using modern Javascript frameworks and custom solutions. Built PMHadv.com using Webpack and a custom Javascript framework. Developed, animated and designed APIs for an interactive, online book using ReactJS. Developed a user interface to manipulate 3D models in Unity3D with C# for an iOS application. Animated and developed a graphics-heavy, mobile-first quiz for Blue Cross Blue Shield using custom Javascript, Greensock, and Webpack.'
					},
					{
						title:       'Front-End Development Team Lead',
						dates:       '2015',
						company:     'Clockwork',
						link:        '//clockwork.com/',
						city:        'Minneapolis, MN',
						description: 'Assumed a leadership role as the company transitioned to a team-based structure. Estimated, planned, and oversaw the team&rsquo;s front&ndash;end production. Provided assistance and guidance to team members.'
					},
					{
						title:       'Senior Front-End Developer',
						dates:       '2012 - 2014',
						company:     'Clockwork',
						link:        '//clockwork.com/',
						city:        'Minneapolis, MN',
						description: 'Developed and managed websites on Drupal, SiteCore and an in-house content management system for such clients as General Mills, The <span class="smallcaps">YMCA</span>, and Gold&rsquo;n Plump Chicken. Built a Swift iOS app for trade show displays for JustBARE Chicken. Built an iOS/Android game for Cracker Jack using the Starling Actionscript library.'
					},
					{
						title:       'Web Consultant',
						dates:       '2010 - 2012',
						company:     'Robot D',
						city:        'Pittsburgh, PA',
						description: 'Developed micro-sites and integrated them into existing web servers for clients that include Reuters and the New York Public Library. Wrote JavaScript and <span class="smallcaps">XML</span> libraries as a communication bridge between dynamic Flash front-end and various <span class="smallcaps">PHP</span> back-end systems.'
					},
					{
						title:       'Senior Developer',
						dates:       '2009 - 2010',
						company:     'Catch New York',
						city:        'New York, NY',
						description: 'Combined management, programming, and creative skills to grow Catch 24 from 6 employees to 24. Transitioned coding practices and educated employees during expansion and merger.'
					},
					{
						title:       'Senior Developer',
						dates:       '2004 - 2009',
						company:     'Catch 24 Advertising & Design',
						city:        'New York, NY',
						description: 'Programmed and animated web sites, games, and banners for clients including Lufthansa, DirecTV, CableVision, <span class="smallcaps">IBM</span>, Oracle and The NY Yankees. Developed strong management and presentation skills as key interactive point of contact for Lufthansa Airlines. Lead the team to set platform coding standards and convert from ActionScript 2.0 to 3.0.'
					},
					{
						title:       'Developer',
						dates:       '2004',
						company:     'The Mixx',
						city:        'New York, NY',
						description: 'Programmed and animated mini-sites for clients such as MSG Entertainment and Scholastic. Translated a strong Object-Oriented programming education into a professional environment. Improved <span class="smallcaps">PHP</span>, MySQL and ActionScript knowledge.'
					},
					{
						title:       'Developer / Designer',
						dates:       '2001 - 2004',
						company:     'Pittsburgh Tissue Engineering Initiative',
						city:        'Pittsburgh, PA',
						description: 'Animated video and effects for a planetarium show to educate children about tissue engineering. Created online Flash games and web site to accompany the show.'
					}
				]
			}
		},
        components:{}
    }
</script>



// WEBPACK FOOTER //
// CV.vue?5e1ef374